import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.commons')
  .filter('timeWindow', timeWindow);

function timeWindow($filter, splitService, moment) {

  function doTimeFilter(_date, _config, _timeZoneId) {
    const format = _config.time;
    if (_timeZoneId) {
      return moment.tz(_date, _timeZoneId).format(format || 'HH:mm');
    } else {
      return moment(_date).format(format || 'HH:mm');
    }
  }

  function doDateFilter(_date, _config, _timeZoneId) {
    const format = _config.date;
    if (_timeZoneId) {
      return moment.tz(_date, _timeZoneId).format(format || 'MM-DD');
    } else {
      return moment(_date).format(format || 'MM-DD');
    }
  }

  return function (_time, timeZoneId) {
    const from = _.get(_time, 'notBefore') || _.get(_time, 'startTime') || _.get(_time, 'eta') || _.get(_time, 'from');
    const to = _.get(_time, 'notAfter') || _.get(_time, 'endTime') || _.get(_time, 'etd') || _.get(_time, 'to');


    if (from && to) {
      const config = splitService.getDateAndTimeConfig();

      let isSameDate;
      let isSameTime;
      if (timeZoneId) {
        isSameDate = moment.tz(from, timeZoneId).isSame(moment.tz(to, timeZoneId), 'day');
        isSameTime = moment.tz(from, timeZoneId).isSame(moment.tz(to, timeZoneId), 'minute');
      } else {
        isSameDate = moment(from).isSame(moment(to), 'day');
        isSameTime = moment(from).isSame(moment(to), 'minute');
      }

      // If both date and time are the same, show only one time
      if (isSameDate && isSameTime) {
        return doDateFilter(from, config, timeZoneId) + ', ' + doTimeFilter(from, config, timeZoneId);
      }

      return isSameDate ?
        doDateFilter(from, config, timeZoneId) + ', ' + doTimeFilter(from, config, timeZoneId) + ' - ' + doTimeFilter(to, config, timeZoneId) :
        doDateFilter(from, config, timeZoneId) + ', ' + doTimeFilter(from, config, timeZoneId) + ' - ' + doDateFilter(to, config, timeZoneId) + ', ' + doTimeFilter(to, config, timeZoneId);
    } else {
      return '---'
    }
  }
}
